import './detailsPhoto.css';
import { useEffect, useRef } from 'react';

export const DetailsPhoto = () => {

    const screen = useRef(null);
    const name = useRef(null);
    const blob = useRef(null);
    /* -- Glow effect -- */

    //const blob = document.getElementById("blob");

    useEffect(() => {
        window.onpointermove = event => { 
            const { clientX, clientY } = event;
            
            blob.current.animate({
                left: `${clientX}px`,
                top: `${clientY}px`
            }, { duration: 3000, fill: "forwards" });
        }
    
        /* -- Text effect -- */
    
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    
        let interval = null;
    
        /* const screen = document.querySelector(".screen"),
            name = document.querySelector(".name"); */
        
        screen.current.onmouseenter = event => {  
            letterAnimation();
        }
    
        setInterval(() =>{
            letterAnimation();
        },5000)
    
        const letterAnimation = () => {
            let iteration = 0;
            
            //clearInterval(interval);
            
            interval = setInterval(() => {
                name.current.innerText = name.current.innerText
                .split("")
                .map((letter, index) => {
                    if(index < iteration) {
                    return name.current.dataset.value[index];
                    }
                
                    return letters[Math.floor(Math.random() * 26)]
                })
                .join("");
                
                if(iteration >= name.current.dataset.value.length){ 
                clearInterval(interval);
                }
                
                iteration += 1 / 3;
            }, 30);
        }
    },[])

    return (
        <>
            <div class="screen" ref={screen}>  
                <div class="screen-image"></div>  
                <div class="screen-overlay"></div>  
                <div class="screen-content">
                
                    <div class="screen-user">
                    <span class="name" ref={name} data-value="2014">2014</span>
                    </div>
                </div>
            </div>

            <div id="blob" ref={blob}></div>
        </>
    )
}